import { Logo } from '../logo'
import { useStyles } from './styles'
type LoadingScreenProps = {
  visible: boolean
}
export const LoadingScreen = ({ visible }: LoadingScreenProps) => {
  const { classes } = useStyles({})
  const userLang = localStorage.getItem('userLanguage') ?? 'en'
  const text =
    userLang === 'en'
      ? 'You’ll never lose the experience you ve gained'
      : 'Ты никогда не потеряешь опыт, который получил.'

  return (
    <div
      data-visible={visible}
      className={classes.root}
    >
      <Logo />
      <div className={classes.text}>{text}</div>
    </div>
  )
}
